module.exports = __webpack_public_path__ + "static/media/demo-lt.8faa0511.png";